import { AgentChannel } from "@common/constants/agent-channel";
import { Message, MessageSentBy, MessageType } from "@common/types/chat";

export type MessageAuthor =
    | { kind: "agent" }
    | { kind: "user"; user: MessageSentBy }
    | { kind: "kick" }
    | { kind: "api" };

interface ResolveMessageAuthorParams {
    message: Pick<Message, "agentChannel" | "user" | "type">;
    canSeeAgentIdentity: boolean;
}

export function resolveMessageAuthor({
    message,
    canSeeAgentIdentity,
}: ResolveMessageAuthorParams): MessageAuthor {
    if (message.type === MessageType.API) {
        return { kind: "api" };
    }
    if (
        canSeeAgentIdentity &&
        message.agentChannel === AgentChannel.AGENT_RUN
    ) {
        return { kind: "agent" };
    }
    if (message.user) {
        return { kind: "user", user: message.user };
    }
    return { kind: "kick" };
}
